import { white, pink25 } from '@zocdoc/branding/colors';

const scrollToElement = ({
    focusState,
    nextItem,
    nextIndex,
    currentItem,
    currentIndex,
}) => {
    const scrollableArea = focusState.getScrollableArea();
    if (scrollableArea) {
        if (nextIndex === (currentIndex + 1) && nextItem.offsetTop > 210) {
            scrollableArea.scrollTop += nextItem.offsetTop - currentItem.offsetTop;
        } else if (nextIndex === (currentIndex - 1)) {
            scrollableArea.scrollTop -= currentItem.offsetTop - nextItem.offsetTop;
        }
    }
};

const removeFocusFromCurrentItem = ({
    focusState,
    currentIndex,
}) => {
    const currentItem = focusState.getItemAtIndex(currentIndex);

    if (currentItem) {
        currentItem.style.backgroundColor = white;
    }

    return currentItem;
};

const addFocusToNextElement = ({
    focusState,
    nextIndex,
}) => {
    const nextItem = focusState.getItemAtIndex(nextIndex);

    if (nextItem) {
        nextItem.style.backgroundColor = pink25;
    }

    return nextItem;
};

export function processFocusChange({
    focusState,
    nextIndex,
    currentIndex,
}) {
    const nextItem = addFocusToNextElement({
        focusState,
        nextIndex,
    });

    if (nextItem && currentIndex !== undefined) {
        const currentItem = removeFocusFromCurrentItem({
            focusState,
            currentIndex,
        });

        scrollToElement({
            focusState,
            nextItem,
            nextIndex,
            currentItem,
            currentIndex,
        });
    }
}
